export default "__VITE_ASSET__BaKYuzrU__"